module.exports = __webpack_public_path__ + "static/media/cloche.5a5bd424.svg";